export default __webpack_public_path__ + "static/media/motorbike_front_wheel.5eceb7a9.png";